import { Routes } from '@angular/router';
import { ShellComponent } from './shell/shell.component';
import { initialize, loggedIn } from '@app/core/guards';
import { provideProfileStore } from '@app/store/profile';
import { usersModalRoutes } from './users/users.modal-routes';
import { assessorsModalRoutes } from './assessors/assessors.modal-routes';
import { coursesModalRoutes } from './courses/courses.modal-routes';
import { schoolsModalRoutes } from './schools/schools.modal-routes';
import { organisationsModalRoutes } from './organisations/organisations.modal-routes';
import { instructorsModalRoutes } from './instructors/instructors.modal-routes';
import { adminsModalRoutes } from './admins/admins.modal-routes';
import { lessonsModalRoutes } from './lessons/lessons.modal-routes';
import { pathwaysModalRoutes } from './pathways/pathways.modal-routes';
import { predefinedPathwaysModalRoutes } from './predefined-pathways/predefined-pathways.modal-routes';
import { packagesModalRoutes } from './packages/packages.modal-routes';
import { licensesModalRoutes } from './licenses/licenses.modal-routes';
import { modulesModalRoutes } from './modules/modules.modal-routes';
import { allMediaModalRoutes } from './all-media/all-media.modal-routes';
import { quizzesModalRoutes } from './quizzes/quizzes.modal-routes';
import { quizQuestionsModalRoutes } from './quiz-questions/quiz-questions.modal-routes';
import { reflectionsModalRoutes } from './reflections/reflections.modal-routes';
import { newsModalRoutes } from './news/news.modal-routes';
import { dialogRoutes } from './dialogs/dialogs.routes';

export const appRoutes: Routes = [
    {
        path: '',
        redirectTo: initialize(),
        pathMatch: 'full',
    },
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.routing').then(({ routes }) => routes),
    },
    {
        path: 'storybook',
        loadChildren: () => import('./storybook/storybook.routing').then(({ routes }) => routes),
    },
    {
        path: '',
        canActivate: [loggedIn()],
        component: ShellComponent,
        providers: [...provideProfileStore()],
        children: [
            {
                path: 'dashboard',
                loadChildren: () => import('./dashboard/dashboard.routing').then(({ routes }) => routes),
            },
            {
                path: 'admins',
                loadChildren: () => import('./admins/admins.routing').then(({ routes }) => routes),
            },
            {
                path: 'users',
                loadChildren: () => import('./users/users.routing').then(({ routes }) => routes),
            },
            {
                path: 'assessors',
                loadChildren: () => import('./assessors/assessors.routing').then(({ routes }) => routes),
            },
            {
                path: 'schools',
                loadChildren: () => import('./schools/schools.routing').then(({ routes }) => routes),
            },
            {
                path: 'organisations',
                loadChildren: () => import('./organisations/organisations.routing').then(({ routes }) => routes),
            },
            {
                path: 'pathways',
                loadChildren: () => import('./pathways/pathways.routing').then(({ routes }) => routes),
            },
            {
                path: 'predefined-pathways',
                loadChildren: () => import('./predefined-pathways/predefined-pathways.routing').then(({ routes }) => routes),
            },
            {
                path: 'packages',
                loadChildren: () => import('./packages/packages.routing').then(({ routes }) => routes),
            },
            {
                path: 'licenses',
                loadChildren: () => import('./licenses/licenses.routing').then(({ routes }) => routes),
            },
            {
                path: 'courses',
                loadChildren: () => import('./courses/courses.routing').then(({ routes }) => routes),
            },
            {
                path: 'modules',
                loadChildren: () => import('./modules/modules.routing').then(({ routes }) => routes),
            },
            {
                path: 'lessons',
                loadChildren: () => import('./lessons/lessons.routing').then(({ routes }) => routes),
            },
            {
                path: 'instructors',
                loadChildren: () => import('./instructors/instructors.routing').then(({ routes }) => routes),
            },
            {
                path: 'quizzes',
                loadChildren: () => import('./quizzes/quizzes.routing').then(({ routes }) => routes),
            },
            {
                path: 'quiz-questions',
                loadChildren: () => import('./quiz-questions/quiz-questions.routing').then(({ routes }) => routes),
            },
            {
                path: 'reflections',
                loadChildren: () => import('./reflections/reflections.routing').then(({ routes }) => routes),
            },
            {
                path: 'media',
                loadChildren: () => import('./all-media/all-media.routing').then(({ routes }) => routes),
            },
            {
                path: 'xero',
                loadChildren: () => import('./xero/xero.routing').then(({ routes }) => routes),
            },
            {
                path: 'profile',
                loadChildren: () => import('./profile/profile.routing').then(({ routes }) => routes),
            },
            {
                path: 'settings',
                loadChildren: () => import('./settings/settings.routing').then(({ routes }) => routes),
            },
            {
                path: 'news',
                loadChildren: () => import('./news/news.routing').then(({ routes }) => routes),
            },
            ...usersModalRoutes,
            ...assessorsModalRoutes,
            ...coursesModalRoutes,
            ...schoolsModalRoutes,
            ...organisationsModalRoutes,
            ...instructorsModalRoutes,
            ...adminsModalRoutes,
            ...lessonsModalRoutes,
            ...pathwaysModalRoutes,
            ...predefinedPathwaysModalRoutes,
            ...packagesModalRoutes,
            ...licensesModalRoutes,
            ...modulesModalRoutes,
            ...allMediaModalRoutes,
            ...quizzesModalRoutes,
            ...quizQuestionsModalRoutes,
            ...reflectionsModalRoutes,
            ...newsModalRoutes,
            ...dialogRoutes,
            {
                path: '**',
                loadChildren: () => import('@error/not-found').then(({ routes }) => routes),
            },
        ],
    },
];
